export default "__VITE_ASSET__ClNsom1Z__"